import { Get } from 'domain/infra/data/api';
import { CAMPANHA_URL } from 'domain/infra/data/env';
import { ExtratoRequest } from 'carteira/src/types/extrato/extratoRequest';
import { ExtratoResponse } from 'carteira/src/types/extrato/extratoResponse';

export class ExtratoCampanhaService {
  async GetExtrato(data: ExtratoRequest, carteiraId: number): Promise<ExtratoResponse[] | Error> {
    let url = `${CAMPANHA_URL}/CarteiraExtrato/Range/${carteiraId}`;

    if (data.From.length !== 0) {
      url += `?From=${data.From}&To=${data.To}`;
    }

    if (data.CampanhaId) {
      url += url.includes('?') ? `&CampanhaId=${data.CampanhaId}` : `?CampanhaId=${data.CampanhaId}`;
    }

    return await Get<ExtratoResponse[]>(url);
  }
}
